import { StatTable } from "components/StatsTable/StatTable";
import { StatTableColumn } from "components/StatsTable/StatTableColumn";
import { Match } from "model/Match/Match";
import { countToArray } from "Utility";
import {
  AltSeasonPointsRules,
  SeasonPointsRules,
} from "model/Tournament/Segment/Season/SeasonPointRules";
import { SeasonPointsOverrides } from "model/Tournament/Segment/Season/Season";
import { selectWithDisplay } from "../Shared";
import { useAppSelector } from "app/hooks";
import {
  Adl3SeasonRecordWithDisplay,
  calculateAdl3SeasonRecords,
} from "model/Records old/Adl3SeasonRecord";

interface Props {
  seasonPoints: SeasonPointsRules | undefined;
  seasonPointsOverrides: SeasonPointsOverrides | undefined;
  altSeasonPoints: AltSeasonPointsRules[] | undefined;
  matchesByPlayday: Match[][];
  numberOfPlaydays: number;
  rosterIds: string[];
  tournamentId: string;
  primaryColor?: string;
  secondaryColor?: string;
}

export const Adl3SeasonTable = ({
  seasonPoints,
  seasonPointsOverrides,
  altSeasonPoints,
  matchesByPlayday,
  numberOfPlaydays,
  rosterIds,
  tournamentId,
  primaryColor,
  secondaryColor,
}: Props) => {
  const records = calculateAdl3SeasonRecords(
    seasonPoints,
    seasonPointsOverrides,
    altSeasonPoints,
    rosterIds,
    matchesByPlayday,
    numberOfPlaydays
  );

  const recordsWithDisplay = useAppSelector((state) =>
    selectWithDisplay(state, records, tournamentId)
  );

  const columns: StatTableColumn<Adl3SeasonRecordWithDisplay>[] = [
    {
      type: "Position",
      sortable: true,
      positionGetter: (arg) => arg.record.position,
    },
    {
      type: "OrgLogoName",
      sortable: true,
      orgIdGetter: (arg) => arg.orgId,
      nameGetter: (arg) => arg.displayName,
    },
    {
      type: "Number",
      header: "Points",
      sortable: true,
      fractionDigits: 0,
      valueGetter: (arg) => arg.record.points,
    },
    ...countToArray(numberOfPlaydays).map((i) => {
      const col: StatTableColumn<Adl3SeasonRecordWithDisplay> = {
        type: "Number",
        header: `M${i}`,
        title: `Match ${i} Points`,
        sortable: true,
        fractionDigits: 0,
        valueGetter: (arg) => arg.record.matchPoints[i - 1],
      };
      return col;
    }),
  ];

  return (
    <StatTable
      thinner={true}
      stats={recordsWithDisplay}
      columns={columns}
      keyGetter={(arg) => arg.displayName}
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
    />
  );
};
